import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import QuestionList from "./QuestionList";
import SuccessIcon from "../../assets/images/success.svg";
import { appConstants } from "../../utils/constants";
import "../../assets/css/question-template.css";
import { default as QuestionItem } from "./QuestionItem";
import Skeleton from "react-loading-skeleton";
import { useDashboardContext } from "../../context/customhook/dashboardHook";
import { QuestionsProvider } from "../../context/provider/questionsProvider";
import { ChildQuestionProvider } from "../../context/provider/childQuestionProvider";

export default function QuetionsWrapper() {
  const { dashboardStates } = useDashboardContext();
  const { t } = useTranslation();
  const [productsQuestions, setProductsQuestions] = useState({
    likeProducts: `${t(appConstants.likeProducts)}${t(appConstants.question)}`,
    improveProducts: `${t(appConstants.improveProducts)}${t(
      appConstants.question
    )}`,
  });

  useEffect(() => {
    if (dashboardStates.parentQuestion) {
      setProductsQuestions({
        likeProducts: `${t(appConstants.likeProducts)}  ${
          dashboardStates.parentQuestion
        }${t(appConstants.question)}`,
        improveProducts: `${t(appConstants.improveProducts)}  ${
          dashboardStates.parentQuestion
        }${t(appConstants.question)}`,
      });
    }
  }, [dashboardStates.parentQuestion, t]);

  return (
    <div>
      <QuestionsProvider>
        {dashboardStates.parentQuestionloading ? (
          <div>
            <Skeleton height={10} count={1} />
          </div>
        ) : (
          <div>
            {dashboardStates.rating !== null ? (
              <div className="question-container">
                {dashboardStates.parentQuestionId ? (
                  <img src={SuccessIcon} alt="logo" className="success-img" />
                ) : null}
                {
                  <div className="container-title">
                    <label className="container-titel-label">
                      {t(
                        dashboardStates.rating &&
                          parseInt(dashboardStates.rating, 10) > 7
                          ? appConstants.wentWell
                          : appConstants.notWentWell
                      )}
                    </label>
                  </div>
                }
                <QuestionList
                  questionsData={dashboardStates.parentQuestiondata}
                  isParentQuestion={true}
                />
              </div>
            ) : null}
          </div>
        )}
      </QuestionsProvider>

      <ChildQuestionProvider>
        {dashboardStates.childQuestionloading ? (
          <div>
            <Skeleton height={10} count={1} />
          </div>
        ) : (
          <div>
            {dashboardStates.parentQuestionId ? (
              <div className="question-container">
                {dashboardStates.childQuestionId ? (
                  <img src={SuccessIcon} alt="logo" className="success-img" />
                ) : null}
                {
                  <div className="container-title">
                    <label className="container-titel-label">
                      {dashboardStates.rating !== null &&
                      parseInt(dashboardStates.rating, 10) > 7
                        ? productsQuestions.likeProducts
                        : productsQuestions.improveProducts}
                    </label>
                  </div>
                }
                <QuestionList
                  questionsData={dashboardStates.childQuestiondata}
                  isParentQuestion={false}
                />
              </div>
            ) : null}
          </div>
        )}
      </ChildQuestionProvider>
    </div>
  );
}
